import { GET_STOREFRONT_CONFIGURATION } from '../../constants/actions/storefront';

export default function getStorefrontConfiguration() {
    return {
        type: GET_STOREFRONT_CONFIGURATION
    };
}
